import React from 'react';

import {Typography, useTheme} from '@mui/material';
import {Loading} from 'presentation/components/Loading/Loading';
import {StyledCard, StyledCardActionArea, StyledIcon} from './styles';
import {ServiceCardProps} from './types';

export function ServiceCard({
	loading,
	handleClick,
	dataTagId,
	dataTestId,
	icon,
	title,
	hasEmphasis,
	...cardProps
}: ServiceCardProps) {
	const {palette} = useTheme();

	return (
		<StyledCardActionArea
			disabled={loading}
			onClick={handleClick}
			data-tag-id={dataTagId}
			data-test-id={dataTestId}>
			<StyledCard variant="outlined" {...cardProps} $hasEmphasis={hasEmphasis}>
				{loading ? (
					<Loading size={16} fullWidth={false} sx={{color: palette.primary.main}} />
				) : (
					<StyledIcon name={icon} size={22} $hasEmphasis={hasEmphasis} />
				)}
				<Typography
					fontWeight={600}
					color={hasEmphasis ? '#fff' : 'text.primary'}
					fontSize={15}>
					{title}
				</Typography>
			</StyledCard>
		</StyledCardActionArea>
	);
}
